<template>
  <common-dialog ref="dialog" width="500px" title="修改标题" :data="data" :form-rules="rules" :save-func="saveFunc"
    show-save-button @closed="onClosed" @close-saved="$emit('close-saved')" close-on-saved>
    <template slot="form">
      <el-form-item label="标题" prop="title" label-width="50px">
        <el-input type="textarea" v-model="data.title" placeholder="请输入标题" :rows="3" spellcheck="false" clearable />
      </el-form-item>
    </template>
  </common-dialog>
</template>
<script>
import commonDialog from '@/components/common/dialog';
import goodsApi from '@/api/pdd/goods';

export default {
  components: { commonDialog },
  data() {
    return {
      data: { title: '' },
      rules: { title: [{ required: true, message: '标题不能为空' }] },
      detail: null,
    }
  },
  methods: {
    openEdit(row) {
      this.detail = {
        goods_id: row.goodsId,
        goods_name: row.goodsName,
        carousel_gallery: row.carouselGalleryList,
        cat_id: row.catId,
        cost_template_id: row.costTemplateId,
        country_id: row.countryId,
        detail_gallery: row.detailGalleryList,
        out_goods_id: row.outerGoodsId,
        goods_type: row.goodsType,
        is_folt: row.isFolt,
        is_pre_sale: row.isPreSale,
        is_refundable: row.isRefundable,
        market_price: row.marketPrice,
        second_hand: row.secondHand == 1,
        shipment_limit_second: row.shipmentLimitSecond,
        sku_list: (row.skuList || []).map(x => ({
          is_onsale: x.is_onsale,
          limit_quantity: x.limit_quantity,
          multi_price: x.multi_price,
          out_sku_sn: x.out_sku_sn,
          price: x.price,
          quantity: 0,
          sku_id: x.sku_id,
          spec_id_list: `[${(x.spec || []).map(s => s.spec_id).join(",")}]`,
          thumb_url: x.thumb_url,
          weight: x.weight,
        })),
      };
      this.data.title = row.goodsName;
      this.$refs.dialog.openEdit(this.data);
    },
    saveFunc() {
      return new Promise((resolve, reject) => {
        if (!this.detail) { reject({ code: 1, msg: '保存失败' }); return; }
        this.detail.goods_name = this.data.title;
        var saveData = {
          dataList: [{
            ...this.detail,
            carousel_gallery: JSON.stringify(this.detail.carousel_gallery),
            detail_gallery: JSON.stringify(this.detail.detail_gallery),
            sku_list: JSON.stringify(this.detail.sku_list),
          }]
        };
        goodsApi.put(saveData).then(res => {
          if (res.data && res.data.length > 0) {
            var html = '';
            res.data.forEach(x => { html += '<div>' + x.errorMsg + '</div>' });
            this.$alert(html, '提示', { dangerouslyUseHTMLString: true, type: 'error' });
            reject({});
          } else {
            resolve({ Code: 0 });
          }
        }).catch(err => reject(err));
      });
    },
    onClosed() {

      this.detail = null;
    },
  }
}
</script>
